__turbopack_context__.v({
  "button": "_9PQwWW_button",
  "buttonInner": "_9PQwWW_buttonInner",
  "buttonInnerHidden": "_9PQwWW_buttonInnerHidden",
  "destructive": "_9PQwWW_destructive",
  "disabled": "_9PQwWW_disabled",
  "elevated": "_9PQwWW_elevated",
  "filled": "_9PQwWW_filled",
  "filledWhite": "_9PQwWW_filledWhite",
  "fullWidth": "_9PQwWW_fullWidth",
  "ghost": "_9PQwWW_ghost",
  "loading": "_9PQwWW_loading",
  "outlined": "_9PQwWW_outlined",
  "small": "_9PQwWW_small",
  "spinner": "_9PQwWW_spinner",
  "spinnerContainer": "_9PQwWW_spinnerContainer",
  "text": "_9PQwWW_text",
  "tonal": "_9PQwWW_tonal",
});
